import React from 'react'
import PropTypes from 'prop-types'
import './text.css'

const Text = (props) => {
  return (
    <div className={`text-container ${props.rootClassName}`}>
      <h3 className="text-thq-about-title-elm">Wer sind wir?</h3>
      <p>
        Wir sind eine Gruppe von Menschen, die fest an die europäische
        Zukunft Georgiens glauben. Unser Ziel ist es, den
        Annäherungsprozess Georgiens an die Europäische Union aktiv zu
        unterstützen und zu stärken. Wir stehen für demokratische Werte,
        Menschenrechte und den Rechtsstaat in Georgien ebenso wie in ganz
        Europa.
      </p>

      <p>
        Unsere Vision ist ein freies, demokratisches und geeintes
        Georgien als vollwertiges Mitglied der europäischen Familie, das sich
        in Frieden, Stabilität und gegenseitigem Respekt weiterentwickelt.
      </p>

      <p>
        Unsere Initiative wurde in Freiburg (Deutschland) gegründet auf
        Initiative georgischer Bürgerinnen und Bürger, die in Georgien und in
        Deutschland leben. Freiburg ist eine ausgeprägte Studierendenstadt
        mit einer großen und sehr internationalen Gemeinschaft. Viele junge
        Menschen aus unterschiedlichen Ländern, Kulturen und sozialen
        Hintergründen leben und lernen hier zusammen. Genau deshalb bietet
        Freiburg ein großes Potenzial für kritischen Austausch, Bildung und
        gesellschaftliches Engagement.
      </p>

      <p>
        Darüber hinaus ist Freiburg ein bedeutender Wissenschaftsstandort.
        Viele Wissenschaftlerinnen und Wissenschaftler sowie Forschende aus
        unterschiedlichen Disziplinen arbeiten hier. Ihre Expertise, ihre
        analytischen Fähigkeiten und ihre Erfahrungen sind für unsere
        Initiative von großem Wert.
      </p>

      <p>
        Wir sind überzeugt, dass der Dialog zwischen Wissenschaft,
        Studierenden und Zivilgesellschaft einen wichtigen Beitrag zur
        Aufklärung und zur Stärkung kritischen Denkens leisten kann. Aus
        diesen Gründen sehen wir Freiburg als einen besonders geeigneten Ort,
        um eine Initiative zu gründen, die sich aktiv für Information,
        Aufklärung und den verantwortungsvollen Umgang mit Medien einsetzt.
      </p>

      <p>
        Der Zweck unserer Gruppe „Stimme Georgiens“ ist es,
        politische, kulturelle und gesellschaftliche Entwicklungen in
        Georgien objektiv darzustellen, zur Bewusstseinsbildung
        beizutragen und verlässliche Informationen über Georgien in der
        deutschen Öffentlichkeit zu verbreiten.
      </p>

      <p>
        Wir sind der Überzeugung, dass hierfür folgende Grundpfeiler
        notwendig sind:
      </p>

      <ol>
        <li>
          <strong>Förderung der europäischen Integration Georgiens.</strong>
          <p>
            Wir unterstützen politische, gesellschaftliche und kulturelle
            Prozesse, die eine Annäherung Georgiens an die Europäische Union
            voranbringen.
          </p>
        </li>

        <li>
          <strong>Stärkung der Demokratie und der Zivilgesellschaft</strong>
          <p>
            Wir setzen uns für eine starke Zivilgesellschaft,
            Meinungsfreiheit, faire Wahlen und unabhängige Institutionen in
            Georgien ein.
          </p>
        </li>

        <li>
          <strong>Bildungs- und Aufklärungsarbeit</strong>
          <p>
            Wir informieren die europäische Öffentlichkeit über die Bedeutung
            des europäischen Weges Georgiens, über seine Chancen, aber auch
            über die Herausforderungen.
          </p>
        </li>

        <li>
          <strong>Enge Zusammenarbeit mit pro-europäischen Kräften</strong>
          <p>
            Wir unterstützen all jene, die sich friedlich und konstruktiv für
            einen europäischen Kurs Georgiens einsetzen in Politik,
            Gesellschaft, Bildung und Kultur.
          </p>
        </li>
      </ol>

      <p>
        Ziel unserer Aktivitäten ist es auch, der deutschen Öffentlichkeit
        sachliche Informationen über die tatsächliche Lage in Georgien
        zugänglich zu machen und aktiv gegen Desinformation und
        Propaganda mit faktenbasierter Analyse vorzugehen.
      </p>

      <p>
        Darüber hinaus sehen wir kulturelle und bildungsbezogene
        Initiativen sowie Veranstaltungen als wichtiges Mittel zur
        Vertiefung der deutsch-georgischen Beziehungen. Diese Aktivitäten
        dienen gleichzeitig der Stärkung und Popularisierung europäischer
        Werte: Demokratie, Freiheit und Menschenrechte.
      </p>

      <p>
        Ein weiteres Anliegen ist der Wissenstransfer: Wir möchten die
        in Deutschland gesammelten Erfahrungen und das Wissen mit der
        georgischen Zivilgesellschaft teilen.
      </p>

      <h4>Zur Umsetzung unserer Ziele verfolgen wir folgende Aktivitäten:</h4>

      <ol>
        <li>
          Organisation von öffentlichen Diskussionen, Treffen,
          Konferenzen, Ausstellungen und kulturellen Veranstaltungen.
        </li>

        <li>
          Durchführung von Informationskampagnen sowie Veröffentlichung
          von Recherchen und analytischen Beiträgen.
        </li>

        <li>
          Nutzung von sozialen Netzwerken und Medienplattformen zur
          Verbreitung der Inhalte und Ziele der Initiative.
        </li>

        <li>
          Aufbau von Netzwerken zwischen NGOs und engagierten Personen.
        </li>

        <li>
          Sichtbarmachung pro-europäischer Stimmen durch gezielte
          Kampagnen.
        </li>

        <li>
          Zusammenarbeit mit Partnerinnen und Partnern aus Politik,
          Wissenschaft und Zivilgesellschaft.
        </li>
      </ol>

      <h4>Mitgliedschaft</h4>

      <p>
        Die Mitgliedschaft in unserer Initiative steht allen offen, die
        unsere Ziele teilen und sich den demokratischen und europäischen
        Werten verpflichtet fühlen.
      </p>

      <p>
        Unsere Initiative handelt im Einklang mit den Gesetzen der
        Bundesrepublik Deutschland.
      </p>
    </div>
  )
}

Text.defaultProps = {
  rootClassName: '',
}

Text.propTypes = {
  rootClassName: PropTypes.string,
}

export default Text
